import Vue from 'vue'

import store from '@/app/store'
// Recovers the store from the local storage.
store.commit('init')

import '@/app/filters'
import '@/app/directives'
import '@/app/plugins'

// TODO: Diese Plugins sollten auch via @app/plugins/index importiert werden.
import vuetify from '@/app/plugins/vuetify'
import i18n from '@/app/plugins/i18n'
import router from '@/app/router'

import '@/common/validations/verify'

import './registry'
import './registerServiceWorker'

Vue.config.productionTip = false

console.log(`NODE_ENV: ${process.env.NODE_ENV}`)
console.log(`VUE_APP_API_URL: ${process.env.VUE_APP_API_URL}`)

import App from '@/app/views/app.vue'

new Vue({
  vuetify,
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app')
